export default {
    free_trial: {
        title: 'Welcome to the MedMatch Network! Enjoy your 14-DAY FREE TRIAL',
        content: '',
    },
    invite_member: {
        title: 'Welcome to the MedMatch Network!',
        content:
            'Invite your colleagues to join MedMatch Network so you can start using all the great features of the platform to manage your referrals',
    },
    workboard: {
        title: 'Workboard',
        content: 'The Workboard updates you on referral status',
    },
    practice: {
        title: 'Section "Practice"',
        content: 'As the MedMatch Administrator, you can control the practice account and membership account from "Practice"',
    },
    activate_physician: {
        title: 'Choose a Doctor',
        content: 'Select a provider to activate from the drop down menu',
    },
    create_referral: {
        title: 'Make a referral',
        content: 'Make a referral to a provider or ancillary services',
    },
    track_referrals: {
        title: 'Track Referrals',
        content: 'Track Referrals made and received here',
    },
    referrals_overview_time_frame: {
        title: 'Choose a time frame',
        content: 'Select a time frame to generate referral overview',
    },
}
